import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { addDevBoxHyperVAcceptedListenerSaga, addDevBoxHyperVListenerSaga } from './add-dev-box-hyper-v';
import { pollNonTerminalDevBoxHyperVListenerSaga } from './poll-non-terminal-dev-box-hyper-v';

export function* rootSaga(): SagaIterator {
    yield all([
        fork(addDevBoxHyperVAcceptedListenerSaga),
        fork(pollNonTerminalDevBoxHyperVListenerSaga),
        fork(addDevBoxHyperVListenerSaga),
    ]);
}
